<template>
  <div class="user">
    <div class="header">
      <a class="logo" href="javascript:;"  @click="$router.push('/')">
        <img src="../assets/img/logo.svg" alt="">
      </a>
      <!-- <a class="menu_btn" href="javascript:;">
        <img src="../assets/img/menu.png" alt="">
      </a> -->
      <a class="quit" href="javascript:;" @click="loginOut">
        退出
      </a>
    </div>
    <div class="content">
      <div class="tab_box_lv1">
        <ul>
          <li>
            <a href="javascript:;" class="tab_item" :class="{checked:true}">
              我的面板
              <i></i>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="tab_item" @click="$router.push({name:'industry-report'})">
              应用管理
              <i></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="tab_box_lv2">
        <ul>
          <li>
            <a href="javascript:;" class="tab_item" :class="{checked:isShow==1}" @click="showTab(1)">
              欢迎页
            </a>
          </li>
          <li>
            <a href="javascript:;" class="tab_item" :class="{checked:isShow==2}" @click="showTab(2)">
              修改个人资料
            </a>
          </li>
          <li>
            <a href="javascript:;" class="tab_item" :class="{checked:isShow==3}" @click="showTab(3)">
              修改个人密码
            </a>
          </li>
          <li>
            <a href="javascript:;" class="tab_item" :class="{checked:isShow==4}" @click="showTab(4)" >
              我的消息
            </a>
          </li>
        </ul>
      </div>
      <div class="hello" v-show="isShow==1">
        <div class="login_msg">
          <div class="tit">
            <img class="tit_phone" src="../assets/img/tit_phone.png" alt="">
            用户
          </div>
          <div class="pl-75 msg_info">
            <div class="mt-15">
              <span class="user_name mr-4">{{userInfo.realName}}</span>
              你好，欢迎您进入内容管理系统！
            </div>
            <div class="mt-15">
              上次登陆时间：
              <span class="time ml-7">{{userInfo.lastLoginTime}}</span>
            </div>
            <div class="mt-15">
              上次登陆IP：
              <span class="time ml-7">{{userInfo.lastLoginIp}}</span>
            </div>
          </div>
        </div>
        <div class="user_msg">
          <div class="tit">
            <img class="tit_setting" src="../assets/img/tit_setting.png" alt="">
            用户信息
          </div>
          <div class="pl-75 msg_info">
            <div class="mt-15 msg_item">
              <i><img class="tit_setting" src="../assets/img/triangle.png" alt=""></i>
              注册时间：{{userInfo.createTime}}
            </div>
            <div class="mt-15 msg_item">
              <i><img class="tit_setting" src="../assets/img/triangle.png" alt=""></i>
              到期时间：{{userInfo.expirationTime}}
            </div>
            <div class="mt-15 msg_item">
              <i><img class="tit_setting" src="../assets/img/triangle.png" alt=""></i>
              下载次数限制：{{userInfo.downloadLimitTimes}}
            </div>
            <div class="mt-15 msg_item">
              <i><img class="tit_setting" src="../assets/img/triangle.png" alt=""></i>
              已下载次数：{{userInfo.downloadTimes}}
            </div>
            <div class="mt-15 msg_item">
              <i><img class="tit_setting" src="../assets/img/triangle.png" alt=""></i>
              我的消息：<span class="red">{{userInfo.messageAmount}}</span><span class="info_link" @click="$router.push('user-msg')">【查看】</span>
            </div>
          </div>
        </div>
      </div>
      <div class="data" v-show="isShow==2">
        <table cellpadding="0" border="0">
          <tr>
            <td>用户名</td>
            <td>{{userInfo.username}}</td>
          </tr>
          <tr>
            <td>最后登录时间</td>
            <td>{{userInfo.lastLoginTime}}</td>
          </tr>
           <tr>
            <td>最后登录IP</td>
            <td>{{userInfo.lastLoginIp}}</td>
          </tr>
           <tr>
            <td>真实姓名</td>
            <td><input type="text" v-model="reData.realName"></td>
          </tr>
          <tr>
            <td>E-mail</td>
            <td><input type="text" v-model="reData.emailAddress"></td>
          </tr>
        </table>
        <div class="btn_box">
          <a class="btn_save" href="javascript:;" @click="dataSave()">保存</a>
          <a class="btn_reset" href="javascript:;" @click="dataClear()">重置</a>
        </div>
      </div>
      <div class="password" v-show="isShow==3">
        <table cellpadding="0" border="0">
          <tr>
            <td>用户名</td>
            <td>{{userInfo.username}}</td>
          </tr>
          <tr>
            <td>E-mail</td>
            <td>{{userInfo.emailAddress}}</td>
          </tr>
          <tr>
            <td>新密码</td>
            <td><input type="text" v-model="newPassword.password"></td>
          </tr>
        </table>
        <div class="btn_box">
          <a class="btn_save" href="javascript:;" @click="passwordSave()">保存</a>
          <a class="btn_reset" href="javascript:;" @click="passwordClear()">重置</a>
        </div>
      </div>
    </div>
    <detail-footer></detail-footer>
  </div>
</template>

<script>
import DetailFooter from './_footer'

export default {
  components: {
    DetailFooter
  },
  data () {
    return {
    	userInfo:{
    		realName:'',
    		username:'',
    		lastLoginIp:'',
    		lastLoginTime:'',
    		createTime:'',
    		expirationTime:'',
    		downloadLimitTimes:'',
    		downloadTimes:'',
    		messageAmount:'',
    		emailAddress:''
    	},
    	reData:{
    		realName:'',
        emailAddress:''
    	},
      newPassword:{
        password:''
      },
    	isShow:1
    }
  },
  mounted() {
    this.getUserInfo();

  },
  methods: {
    loginOut(){
      window.sessionStorage.removeItem("accentToken")
      this.$router.push("login");
    },
  	showTab(index){
      if(index==4){
        this.$router.push('user-msg');
      }else{
        this.isShow = index;
      }	
  	},
  	getUserInfo() {
  		this.$axios.get('/api/web/phone/personal-center/get-profile', {}).then((res)=>{
        this.userInfo = res.data;
        console.log(this.userInfo)
        this.reData = this.getObj(this.userInfo);
        if(this.userInfo.downloadLimitTimes == -1){
          this.userInfo.downloadLimitTimes = '无上限';
        }
      })
    },
    // 阻止深复制
    getObj(source) { 
       return JSON.parse(JSON.stringify(source));
    },
    dataSave(){
      if (!this.constant.validate.email.test(this.reData.emailAddress)) {
        this.Toast('请输入正确的邮箱格式');
        return;
      }
      if (!this.reData.realName) {
        this.Toast('真实姓名不能为空');
        return;
      }
      if (!this.constant.validate.realName.test(this.reData.realName)) {
        this.Toast('请重新输入真实名称');
        return;
      }
      this.$axios.postJson('/api/web/phone/personal-center/edit-profile',this.reData).then(res => {
        if(res.code != 200){
          this.Toast( res.message );
        }else{
          this.Toast( "修改成功" );
          this.userInfo = this.reData;
        }
      })
    },
    dataClear(){
      this.reData = this.getObj(this.userInfo);
    },
    passwordSave(){

      if (!this.newPassword.password) {
        this.Toast('请输入新密码');
        return;
      }
      if (!this.constant.validate.password.test(this.newPassword.password)) {
        this.Toast('请输入6-12位新密码');
        return;
      }
      this.$router.push({name:'result',query:{route:'user',password:this.newPassword.password}});
    },
    passwordClear(){
      this.newPassword.password = '';
    },

  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';

  .user {
    background: #F5F5F5;
    min-height: 100vh;
    box-sizing:border-box;
    position: relative;
  }
  .pl-75{
    padding-left: 75px;
  }
  .mt-15{
    margin-top: 15px;
  }
  .header{
    height: 54px;
    background: #fff;
    border-bottom: 2px solid #f5f5f5;
    top: 0;
    left: 0;
    right: 0;
    position:fixed;
    z-index: 99;
    .logo{
      display: inline-block;
      // width: 155px;
      // height: 24px;
      position: absolute;
      top: 15px;
      left: 15px;
      img{
        height: 35px;
      }
    }
    .menu_btn{
      display: inline-block;
      position: absolute;
      top: 13px;
      right: 13px;
      width: 29px;
      height: 29px;
      img{
        width:100%;
        height:100%;
      }
    }
    .quit{
      display: inline-block;
      position: absolute;
      top: 15px;
      right: 18px;
      color: #fff;
      font-size: 16px;
    }
  }
  .tab_box_lv1{
    height: 50px;
    background: #F5F5F5;
    ul{
      padding: 0;
      margin: 0;
      width: 100%;
      display: inline-block;
    }
    ul::after{
      content: ' ';
      clear: both;
    }
    ul li{
      margin: 0;
      display: inline-block;
      width: 50%;
      float: left;
      box-sizing: border-box;
    }
    .tab_item{
      display: inline-block;
      width: 100%;
      padding: 10px 0;
      color: #999999;
      font-size:20px;
      box-sizing: border-box;
      position: relative;
      i{
        width: 100%;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: #E0E0E0;
      }
    }
    .tab_item.checked{
      color: #64A9FF;
      i{
        background: #64A9FF;
      }
    }

  }
  .tab_box_lv2{
    height: 40px;
    background: #F5F5F5;
    ul{
      padding: 0;
      margin: 0;
      width: 100%;
      display: inline-block;
      padding-left: 15px;
      box-sizing: border-box;
      border-bottom: 1px solid #E0E0E0;
    }
    ul::after{
      content: ' ';
      clear: both;
    }
    ul li{
      margin: 0;
      display: inline-block;
      float: left;
      box-sizing: border-box;
      margin-right: 22px;
    }
    .tab_item{
      display: inline-block;
      width: 100%;
      line-height: 40px;
      color: #666666;
      font-size:14px;
      box-sizing: border-box;
    }
    .tab_item.checked{
      color: #64A9FF;
    }

  }
  .content {
    min-height: calc(100vh - 66px);
    box-sizing: border-box;
    padding-top: 54px;
    .hello{
      padding: 0 15px;
      text-align: left;
      .login_msg{
        padding-top: 20px;
        padding-bottom: 10px;
        .tit{
          position: relative;
          padding-left: 25px;
          line-height: 26px;
          color: #333333;
          font-size: 16px;
        }
        img{
          position: absolute;
          left: 0;
          top: 0;
        }
        .tit_phone{
          width: 16px;
          height: 26px;
        }
        .msg_info{
          font-size: 13px;
          color: #666666;
          .user_name{
            color: #64A9FF;
          }
          .time{
            color: #FD6262;
          }
        }
      }
      .user_msg{
        padding-top: 20px;
        padding-bottom: 10px;
        .tit{
          position: relative;
          padding-left: 27px;
          line-height: 21px;
          color: #333333;
          font-size: 16px;
        }
        img{
          position: absolute;
          left: 0;
          top: 0;
        }
        .tit_setting{
          width: 23px;
          height: 21px;
        }
        .msg_info{
          font-size: 14px;
          color: #666666;
          .msg_item{
            position: relative;
            padding-left: 15px;
            .info_link{
              color: #64A9FF;
            }
            .red{
              color: #FD6262;
            }
            i{
              display: inline-block;
              width: 6px;
              height: 11px;
              position: absolute;
              left: 0;
              top: 4px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
          .time{
            color: #FD6262;
          }
        }
      }
    }
    .data{
      padding: 0 15px;
      text-align: left;
      table{
        margin: 40px 20px 50px 20px ;
        tr>td{
        	min-width: 84px;
          padding: 15px;
          font-size: 14px;
          color: #666666;
        }
      }
      .btn_box{
        margin: 0 20px 0 20px ;
        overflow:hidden;
        a{
          display: inline-block;
          width:93px;
          height:31px;
          background:rgba(100,169,255,1);
          border-radius:5px;
          font-size: 18px;
          color: #ffffff;
          float: left;
          text-align: center;
          line-height: 31px;
        }
        .btn_reset{
          float: right;
          color: rgba(100,169,255,1);
          background: #fff;
          border:1px solid rgba(100,169,255,1);
        }
      }
    }
    .password{
      padding: 0 15px;
      text-align: left;
      table{
        margin: 40px 20px 50px 20px ;
        tr>td{
          padding: 15px;
          font-size: 14px;
          color: #666666;
        }
        input{
          padding-left: 5px;
          width:166px;
          height:27px;
          border-radius:2px;
          border:1px solid rgba(197,197,197,1);
        }
      }
      .btn_box{
        margin: 0 20px 0 20px ;
        overflow:hidden;
        a{
          display: inline-block;
          width:93px;
          height:31px;
          background:rgba(100,169,255,1);
          border-radius:5px;
          font-size: 18px;
          color: #ffffff;
          float: left;
          text-align: center;
          line-height: 31px;
        }
        .btn_reset{
          float: right;
          color: rgba(100,169,255,1);
          background: #fff;
          border:1px solid rgba(100,169,255,1);
        }
      }
    }


    .page{
      padding: 25px;
      .page_box{
        position: relative;
        margin: 0 auto;
        width: 112px;
        color: #666666;
        font-size: 14px;
        .prev{
          position: absolute;
          left: 0;
          top: 2px;
          width: 16px;
          height: 16px;
        }
        .next{
          position: absolute;
          right:0;
          top: 2px;
          width: 16px;
          height: 16px;
        }
        img{
          width: 16px;
          height: 16px;
          content:normal !important;
        }
      }
    }
  }
  .footer{
    box-sizing: border-box;
    height: 66px;
    background: #0C324C;
    padding: 12px 0;
    li{
      color: #fff;
      font-size: 13px;
      height: 18px;
      span{
        width:6px;
        display: inline-block;
        text-align: center;
      }
      a{
        color: #fff;
      }
    }
    .footer_tip{
      margin-top: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user.vue